import t, { useCallback as n, useEffect as r, memo as e, useMemo as o, useState as u } from "react";
import { useFormikContext as a } from "formik";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var _i = function i(t, n) {
  return (_i = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (t, n) {
    t.__proto__ = n;
  } || function (t, n) {
    for (var r in n) n.hasOwnProperty(r) && (t[r] = n[r]);
  })(t, n);
};
var _c = function c() {
  return (_c = Object.assign || function (t) {
    for (var n, r = 1, e = arguments.length; r < e; r++) for (var o in n = arguments[r]) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    return t;
  }).apply(this, arguments);
};
function f(t) {
  var n = "function" == typeof Symbol && t[Symbol.iterator],
    r = 0;
  return n ? n.call(t) : {
    next: function next() {
      return t && r >= t.length && (t = void 0), {
        value: t && t[r++],
        done: !t
      };
    }
  };
}
function l(t, n) {
  var r = "function" == typeof Symbol && t[Symbol.iterator];
  if (!r) return t;
  var e,
    o,
    u = r.call(t),
    a = [];
  try {
    for (; (void 0 === n || n-- > 0) && !(e = u.next()).done;) a.push(e.value);
  } catch (t) {
    o = {
      error: t
    };
  } finally {
    try {
      e && !e.done && (r = u.return) && r.call(u);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}
function s(t) {
  return this instanceof s ? (this.v = t, this) : new s(t);
}
var p = Object.freeze({
    __proto__: null,
    __extends: function __extends(t, n) {
      function r() {
        this.constructor = t;
      }
      _i(t, n), t.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
    },
    get __assign() {
      return _c;
    },
    __rest: function __rest(t, n) {
      var r = {};
      for (var e in t) Object.prototype.hasOwnProperty.call(t, e) && n.indexOf(e) < 0 && (r[e] = t[e]);
      if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for (e = Object.getOwnPropertySymbols(t); o < e.length; o++) n.indexOf(e[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, e[o]) && (r[e[o]] = t[e[o]]);
      }
      return r;
    },
    __decorate: function __decorate(t, n, r, e) {
      var o,
        u = arguments.length,
        a = u < 3 ? n : null === e ? e = Object.getOwnPropertyDescriptor(n, r) : e;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(t, n, r, e);else for (var i = t.length - 1; i >= 0; i--) (o = t[i]) && (a = (u < 3 ? o(a) : u > 3 ? o(n, r, a) : o(n, r)) || a);
      return u > 3 && a && Object.defineProperty(n, r, a), a;
    },
    __param: function __param(t, n) {
      return function (r, e) {
        n(r, e, t);
      };
    },
    __metadata: function __metadata(t, n) {
      if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, n);
    },
    __awaiter: function __awaiter(t, n, r, e) {
      return new (r || (r = Promise))(function (o, u) {
        function a(t) {
          try {
            c(e.next(t));
          } catch (t) {
            u(t);
          }
        }
        function i(t) {
          try {
            c(e.throw(t));
          } catch (t) {
            u(t);
          }
        }
        function c(t) {
          t.done ? o(t.value) : new r(function (n) {
            n(t.value);
          }).then(a, i);
        }
        c((e = e.apply(t, n || [])).next());
      });
    },
    __generator: function __generator(t, n) {
      var r,
        e,
        o,
        u,
        a = {
          label: 0,
          sent: function sent() {
            if (1 & o[0]) throw o[1];
            return o[1];
          },
          trys: [],
          ops: []
        };
      return u = {
        next: i(0),
        throw: i(1),
        return: i(2)
      }, "function" == typeof Symbol && (u[Symbol.iterator] = function () {
        return this;
      }), u;
      function i(u) {
        return function (i) {
          return function (u) {
            if (r) throw new TypeError("Generator is already executing.");
            for (; a;) try {
              if (r = 1, e && (o = 2 & u[0] ? e.return : u[0] ? e.throw || ((o = e.return) && o.call(e), 0) : e.next) && !(o = o.call(e, u[1])).done) return o;
              switch (e = 0, o && (u = [2 & u[0], o.value]), u[0]) {
                case 0:
                case 1:
                  o = u;
                  break;
                case 4:
                  return a.label++, {
                    value: u[1],
                    done: !1
                  };
                case 5:
                  a.label++, e = u[1], u = [0];
                  continue;
                case 7:
                  u = a.ops.pop(), a.trys.pop();
                  continue;
                default:
                  if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === u[0] || 2 === u[0])) {
                    a = 0;
                    continue;
                  }
                  if (3 === u[0] && (!o || u[1] > o[0] && u[1] < o[3])) {
                    a.label = u[1];
                    break;
                  }
                  if (6 === u[0] && a.label < o[1]) {
                    a.label = o[1], o = u;
                    break;
                  }
                  if (o && a.label < o[2]) {
                    a.label = o[2], a.ops.push(u);
                    break;
                  }
                  o[2] && a.ops.pop(), a.trys.pop();
                  continue;
              }
              u = n.call(t, a);
            } catch (t) {
              u = [6, t], e = 0;
            } finally {
              r = o = 0;
            }
            if (5 & u[0]) throw u[1];
            return {
              value: u[0] ? u[1] : void 0,
              done: !0
            };
          }([u, i]);
        };
      }
    },
    __exportStar: function __exportStar(t, n) {
      for (var r in t) n.hasOwnProperty(r) || (n[r] = t[r]);
    },
    __values: f,
    __read: l,
    __spread: function __spread() {
      for (var t = [], n = 0; n < arguments.length; n++) t = t.concat(l(arguments[n]));
      return t;
    },
    __spreadArrays: function __spreadArrays() {
      for (var t = 0, n = 0, r = arguments.length; n < r; n++) t += arguments[n].length;
      var e = Array(t),
        o = 0;
      for (n = 0; n < r; n++) for (var u = arguments[n], a = 0, i = u.length; a < i; a++, o++) e[o] = u[a];
      return e;
    },
    __await: s,
    __asyncGenerator: function __asyncGenerator(t, n, r) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var e,
        o = r.apply(t, n || []),
        u = [];
      return e = {}, a("next"), a("throw"), a("return"), e[Symbol.asyncIterator] = function () {
        return this;
      }, e;
      function a(t) {
        o[t] && (e[t] = function (n) {
          return new Promise(function (r, e) {
            u.push([t, n, r, e]) > 1 || i(t, n);
          });
        });
      }
      function i(t, n) {
        try {
          (r = o[t](n)).value instanceof s ? Promise.resolve(r.value.v).then(c, f) : l(u[0][2], r);
        } catch (t) {
          l(u[0][3], t);
        }
        var r;
      }
      function c(t) {
        i("next", t);
      }
      function f(t) {
        i("throw", t);
      }
      function l(t, n) {
        t(n), u.shift(), u.length && i(u[0][0], u[0][1]);
      }
    },
    __asyncDelegator: function __asyncDelegator(t) {
      var n, r;
      return n = {}, e("next"), e("throw", function (t) {
        throw t;
      }), e("return"), n[Symbol.iterator] = function () {
        return this;
      }, n;
      function e(e, o) {
        n[e] = t[e] ? function (n) {
          return (r = !r) ? {
            value: s(t[e](n)),
            done: "return" === e
          } : o ? o(n) : n;
        } : o;
      }
    },
    __asyncValues: function __asyncValues(t) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var n,
        r = t[Symbol.asyncIterator];
      return r ? r.call(t) : (t = f(t), n = {}, e("next"), e("throw"), e("return"), n[Symbol.asyncIterator] = function () {
        return this;
      }, n);
      function e(r) {
        n[r] = t[r] && function (n) {
          return new Promise(function (e, o) {
            (function (t, n, r, e) {
              Promise.resolve(e).then(function (n) {
                t({
                  value: n,
                  done: r
                });
              }, n);
            })(e, o, (n = t[r](n)).done, n.value);
          });
        };
      }
    },
    __makeTemplateObject: function __makeTemplateObject(t, n) {
      return Object.defineProperty ? Object.defineProperty(t, "raw", {
        value: n
      }) : t.raw = n, t;
    },
    __importStar: function __importStar(t) {
      if (t && t.__esModule) return t;
      var n = {};
      if (null != t) for (var r in t) Object.hasOwnProperty.call(t, r) && (n[r] = t[r]);
      return n.default = t, n;
    },
    __importDefault: function __importDefault(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
  }),
  h = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function _(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function y(t, n) {
  return t(n = {
    exports: {}
  }, n.exports), n.exports;
}
var v = y(function (n, r) {
  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.default = function (n, r) {
    void 0 === r && (r = 0);
    var e = t.useRef(!1),
      o = t.useRef(),
      u = t.useRef(n),
      a = t.useCallback(function () {
        return e.current;
      }, []),
      i = t.useCallback(function () {
        e.current = !1, o.current && clearTimeout(o.current), o.current = setTimeout(function () {
          e.current = !0, u.current();
        }, r);
      }, [r]),
      c = t.useCallback(function () {
        e.current = null, o.current && clearTimeout(o.current);
      }, []);
    return t.useEffect(function () {
      u.current = n;
    }, [n]), t.useEffect(function () {
      return i(), c;
    }, [r]), [a, c, i];
  };
});
_(v);
var d = _(y(function (n, r) {
    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var e = p.__importDefault(v);
    r.default = function (n, r, o) {
      void 0 === r && (r = 0), void 0 === o && (o = []);
      var u = e.default(n, r),
        a = u[0],
        i = u[1],
        c = u[2];
      return t.useEffect(c, o), [a, i];
    };
  })),
  b = /^\[object .+?Constructor\]$/,
  g = /^(?:0|[1-9]\d*)$/,
  m = "object" == typeof h && h && h.Object === Object && h,
  w = "object" == typeof self && self && self.Object === Object && self,
  O = m || w || Function("return this")();
function j(t, n, r) {
  switch (r.length) {
    case 0:
      return t.call(n);
    case 1:
      return t.call(n, r[0]);
    case 2:
      return t.call(n, r[0], r[1]);
    case 3:
      return t.call(n, r[0], r[1], r[2]);
  }
  return t.apply(n, r);
}
function S(t, n) {
  return !!(t ? t.length : 0) && function (t, n, r) {
    if (n != n) return function (t, n, r, e) {
      var o = t.length,
        u = r + (e ? 1 : -1);
      for (; e ? u-- : ++u < o;) if (n(t[u], u, t)) return u;
      return -1;
    }(t, k, r);
    var e = r - 1,
      o = t.length;
    for (; ++e < o;) if (t[e] === n) return e;
    return -1;
  }(t, n, 0) > -1;
}
function P(t, n, r) {
  for (var e = -1, o = t ? t.length : 0; ++e < o;) if (r(n, t[e])) return !0;
  return !1;
}
function x(t, n) {
  for (var r = -1, e = t ? t.length : 0, o = Array(e); ++r < e;) o[r] = n(t[r], r, t);
  return o;
}
function I(t, n) {
  for (var r = -1, e = n.length, o = t.length; ++r < e;) t[o + r] = n[r];
  return t;
}
function k(t) {
  return t != t;
}
function A(t, n) {
  return t.has(n);
}
function E(t, n) {
  return function (r) {
    return t(n(r));
  };
}
var R,
  T = Array.prototype,
  M = Function.prototype,
  $ = Object.prototype,
  C = O["__core-js_shared__"],
  J = (R = /[^.]+$/.exec(C && C.keys && C.keys.IE_PROTO || "")) ? "Symbol(src)_1." + R : "",
  N = M.toString,
  V = $.hasOwnProperty,
  D = $.toString,
  F = RegExp("^" + N.call(V).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
  G = O.Symbol,
  z = E(Object.getPrototypeOf, Object),
  q = $.propertyIsEnumerable,
  B = T.splice,
  H = G ? G.isConcatSpreadable : void 0,
  K = Object.getOwnPropertySymbols,
  L = Math.max,
  Q = at(O, "Map"),
  U = at(Object, "create");
function W(t) {
  var n = -1,
    r = t ? t.length : 0;
  for (this.clear(); ++n < r;) {
    var e = t[n];
    this.set(e[0], e[1]);
  }
}
function X(t) {
  var n = -1,
    r = t ? t.length : 0;
  for (this.clear(); ++n < r;) {
    var e = t[n];
    this.set(e[0], e[1]);
  }
}
function Y(t) {
  var n = -1,
    r = t ? t.length : 0;
  for (this.clear(); ++n < r;) {
    var e = t[n];
    this.set(e[0], e[1]);
  }
}
function Z(t) {
  var n = -1,
    r = t ? t.length : 0;
  for (this.__data__ = new Y(); ++n < r;) this.add(t[n]);
}
function tt(t, n) {
  var r = yt(t) || pt(t) ? function (t, n) {
      for (var r = -1, e = Array(t); ++r < t;) e[r] = n(r);
      return e;
    }(t.length, String) : [],
    e = r.length,
    o = !!e;
  for (var u in t) !n && !V.call(t, u) || o && ("length" == u || lt(u, e)) || r.push(u);
  return r;
}
function nt(t, n) {
  for (var r, e, o = t.length; o--;) if ((r = t[o][0]) === (e = n) || r != r && e != e) return o;
  return -1;
}
function rt(t) {
  return !(!bt(t) || (n = t, J && J in n)) && (dt(t) || function (t) {
    var n = !1;
    if (null != t && "function" != typeof t.toString) try {
      n = !!(t + "");
    } catch (t) {}
    return n;
  }(t) ? F : b).test(function (t) {
    if (null != t) {
      try {
        return N.call(t);
      } catch (t) {}
      try {
        return t + "";
      } catch (t) {}
    }
    return "";
  }(t));
  var n;
}
function et(t) {
  if (!bt(t)) return function (t) {
    var n = [];
    if (null != t) for (var r in Object(t)) n.push(r);
    return n;
  }(t);
  var n,
    r,
    e,
    o = (r = (n = t) && n.constructor, e = "function" == typeof r && r.prototype || $, n === e),
    u = [];
  for (var a in t) ("constructor" != a || !o && V.call(t, a)) && u.push(a);
  return u;
}
function ot(t) {
  return function (t, n, r) {
    var e = n(t);
    return yt(t) ? e : I(e, r(t));
  }(t, mt, ct);
}
function ut(t, n) {
  var r,
    e,
    o = t.__data__;
  return ("string" == (e = typeof (r = n)) || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== r : null === r) ? o["string" == typeof n ? "string" : "hash"] : o.map;
}
function at(t, n) {
  var r = function (t, n) {
    return null == t ? void 0 : t[n];
  }(t, n);
  return rt(r) ? r : void 0;
}
W.prototype.clear = function () {
  this.__data__ = U ? U(null) : {};
}, W.prototype.delete = function (t) {
  return this.has(t) && delete this.__data__[t];
}, W.prototype.get = function (t) {
  var n = this.__data__;
  if (U) {
    var r = n[t];
    return "__lodash_hash_undefined__" === r ? void 0 : r;
  }
  return V.call(n, t) ? n[t] : void 0;
}, W.prototype.has = function (t) {
  var n = this.__data__;
  return U ? void 0 !== n[t] : V.call(n, t);
}, W.prototype.set = function (t, n) {
  return this.__data__[t] = U && void 0 === n ? "__lodash_hash_undefined__" : n, this;
}, X.prototype.clear = function () {
  this.__data__ = [];
}, X.prototype.delete = function (t) {
  var n = this.__data__,
    r = nt(n, t);
  return !(r < 0) && (r == n.length - 1 ? n.pop() : B.call(n, r, 1), !0);
}, X.prototype.get = function (t) {
  var n = this.__data__,
    r = nt(n, t);
  return r < 0 ? void 0 : n[r][1];
}, X.prototype.has = function (t) {
  return nt(this.__data__, t) > -1;
}, X.prototype.set = function (t, n) {
  var r = this.__data__,
    e = nt(r, t);
  return e < 0 ? r.push([t, n]) : r[e][1] = n, this;
}, Y.prototype.clear = function () {
  this.__data__ = {
    hash: new W(),
    map: new (Q || X)(),
    string: new W()
  };
}, Y.prototype.delete = function (t) {
  return ut(this, t).delete(t);
}, Y.prototype.get = function (t) {
  return ut(this, t).get(t);
}, Y.prototype.has = function (t) {
  return ut(this, t).has(t);
}, Y.prototype.set = function (t, n) {
  return ut(this, t).set(t, n), this;
}, Z.prototype.add = Z.prototype.push = function (t) {
  return this.__data__.set(t, "__lodash_hash_undefined__"), this;
}, Z.prototype.has = function (t) {
  return this.__data__.has(t);
};
var it = K ? E(K, Object) : wt,
  ct = K ? function (t) {
    for (var n = []; t;) I(n, it(t)), t = z(t);
    return n;
  } : wt;
function ft(t) {
  return yt(t) || pt(t) || !!(H && t && t[H]);
}
function lt(t, n) {
  return !!(n = null == n ? 9007199254740991 : n) && ("number" == typeof t || g.test(t)) && t > -1 && t % 1 == 0 && t < n;
}
function st(t) {
  if ("string" == typeof t || function (t) {
    return "symbol" == typeof t || gt(t) && "[object Symbol]" == D.call(t);
  }(t)) return t;
  var n = t + "";
  return "0" == n && 1 / t == -1 / 0 ? "-0" : n;
}
function pt(t) {
  return function (t) {
    return gt(t) && vt(t);
  }(t) && V.call(t, "callee") && (!q.call(t, "callee") || "[object Arguments]" == D.call(t));
}
var ht,
  _t,
  yt = Array.isArray;
function vt(t) {
  return null != t && function (t) {
    return "number" == typeof t && t > -1 && t % 1 == 0 && t <= 9007199254740991;
  }(t.length) && !dt(t);
}
function dt(t) {
  var n = bt(t) ? D.call(t) : "";
  return "[object Function]" == n || "[object GeneratorFunction]" == n;
}
function bt(t) {
  var n = typeof t;
  return !!t && ("object" == n || "function" == n);
}
function gt(t) {
  return !!t && "object" == typeof t;
}
function mt(t) {
  return vt(t) ? tt(t, !0) : et(t);
}
function wt() {
  return [];
}
var Ot = (ht = function ht(t, n) {
    return null == t ? {} : (n = x(function t(n, r, e, o, u) {
      var a = -1,
        i = n.length;
      for (e || (e = ft), u || (u = []); ++a < i;) {
        var c = n[a];
        r > 0 && e(c) ? r > 1 ? t(c, r - 1, e, o, u) : I(u, c) : o || (u[u.length] = c);
      }
      return u;
    }(n, 1), st), function (t, n) {
      return function (t, n, r) {
        for (var e = -1, o = n.length, u = {}; ++e < o;) {
          var a = n[e],
            i = t[a];
          r(i, a) && (u[a] = i);
        }
        return u;
      }(t = Object(t), n, function (n, r) {
        return r in t;
      });
    }(t, function (t, n, r, e) {
      var o,
        u = -1,
        a = S,
        i = !0,
        c = t.length,
        f = [],
        l = n.length;
      if (!c) return f;
      r && (n = x(n, (o = r, function (t) {
        return o(t);
      }))), e ? (a = P, i = !1) : n.length >= 200 && (a = A, i = !1, n = new Z(n));
      t: for (; ++u < c;) {
        var s = t[u],
          p = r ? r(s) : s;
        if (s = e || 0 !== s ? s : 0, i && p == p) {
          for (var h = l; h--;) if (n[h] === p) continue t;
          f.push(s);
        } else a(n, p, e) || f.push(s);
      }
      return f;
    }(ot(t), n)));
  }, _t = L(void 0 === _t ? ht.length - 1 : _t, 0), function () {
    for (var t = arguments, n = -1, r = L(t.length - _t, 0), e = Array(r); ++n < r;) e[n] = t[_t + n];
    n = -1;
    for (var o = Array(_t + 1); ++n < _t;) o[n] = t[n];
    return o[_t] = e, j(ht, this, o);
  }),
  jt = function jt() {
    return function () {
      var t = u(!1),
        n = t[0],
        e = t[1];
      return r(function () {
        return e(!0);
      }, []), n;
    }() && !!window;
  },
  St = function St(t, r) {
    var e = t.initialValues,
      u = r.name,
      a = r.hashInitials,
      i = r.hashSpecificity,
      c = u + "_",
      f = o(function () {
        return a ? "" + c + function (t, n) {
          void 0 === n && (n = 7);
          var r = 0;
          try {
            for (var e = JSON.stringify(t).replace(/\{|\"|\}|\:|,/g, ""), o = e.length, u = 0; u < o; u++) r += e.charCodeAt(u) * n;
          } catch (t) {
            r = 0;
          }
          return r;
        }(e, i) : u;
      }, [u, a, JSON.stringify(e), i]),
      l = function (t) {
        var n = t.storage,
          r = void 0 === n ? "localStorage" : n,
          e = jt();
        switch (r) {
          case "sessionStorage":
            return e ? window.sessionStorage : void 0;
          case "localStorage":
            return e ? window.localStorage : void 0;
          default:
            return r;
        }
      }(r);
    return [o(function () {
      return l ? l.getItem(f) : null;
    }, [f, l]), n(function (t) {
      l && (l.setItem(f, JSON.stringify(t)), Object.keys(l).forEach(function (t) {
        t.indexOf(c) > -1 && t !== f && l.removeItem(t);
      }));
    }, [l])];
  },
  Pt = function Pt(t, e) {
    var o = e.debounce,
      u = void 0 === o ? 300 : o,
      a = e.persistInvalid,
      i = e.ignoreValues,
      f = t.values,
      l = t.setValues,
      s = t.isValid,
      p = t.initialValues,
      h = St(t, e),
      _ = h[0],
      y = h[1],
      v = JSON.stringify(f),
      b = n(function () {
        if (s || a) {
          var t = i ? Ot(f, i) : f;
          y(t);
        }
      }, [v, s, a]);
    r(function () {
      if (_) try {
        var t = JSON.parse(_),
          n = _c(_c({}, p), t);
        v !== JSON.stringify(n) && l(n);
      } catch (t) {
        console.error("Parse persisted values is not possible", t);
      }
    }, [_]), d(b, u, [v, s, a]);
  },
  xt = e(function (t) {
    var n = a();
    return Pt(n, t), null;
  });
export { xt as PersistFormikValues, Pt as usePersistFormikValues };